import { Pipe, PipeTransform } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Pipe({
    name: "formControlHasError",
    pure: false
})
export class FormControlHasErrorPipe implements PipeTransform {
    public transform(formGroup: AbstractControl, controlName?: string): boolean {
        if (!controlName) {
            return formGroup.invalid || false;
        }

        const control = formGroup.get(controlName);
        return (control?.invalid && control?.touched) || false;
    }
}
